<template>
	<div>
		<card>
			<Row style="padding-top: 20px;">
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">客户搜索</span>
					<Input v-model="name"  placeholder="搜索系统内所有客户" />
				</div>

				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">状态</span>
					<Select v-model="status"  clearable placeholder="状态">
						<Option v-for="item in statusFilters" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">星级</span>
					<Select v-model="start"  clearable placeholder="星级">
						<Option v-for="item in starsFilters" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">未跟进天数</span>
					<Input v-model="notFollowTimeValue"  placeholder="未跟进天数" style="width: 150px" />
				</div>
				</Col>
			</Row>
			<Row style="padding-top: 20px;">
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">申请时间</span>
					<DatePicker type="daterange" :value="apply_time" placeholder="申请时间" @on-change="applyTimeChange">
					</DatePicker>
					</Cascader>
				</div>

				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
					<div class="input-group">
						<span class="input-group-addon">备注</span>
						<Input v-model="remark"  placeholder="备注" style="width: 150px"/>
					</div>
				</Col>
				<!--Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">状态</span>
					<Select v-model="status" placeholder="状态" @on-change="mySearchByStatus">

						<Option v-for="item in statusFilters" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col-->
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">备注时间</span>
					<DatePicker type="daterange" :value="updated_at" placeholder="备注时间" @on-change="updatedTimeChange">
					</DatePicker>
					</Cascader>
				</div>	
				</Col>
				<Col :xs="{ span: 12 }" :md="{ span: 6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">重复申请时间</span>
					<DatePicker type="daterange" :value="re_time" placeholder="重复申请时间" @on-change="reTimeChange">
					</DatePicker>
				</div>
				</Col>
			</Row>
			<Row style="padding-top: 20px;">
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }" v-if="this.userInfo.media_is_open == true">
				<div class="input-group">
					<span class="input-group-addon">来源</span>
					<Select v-model="media" clearable  style="width:200px" placeholder="媒体代码" >
						<Option v-for="item in categoryList" :value="item.value" :key="item.value">{{ item.label }}</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
					<div class="input-group">
						<span class="input-group-addon">申请额度</span>
						<Input v-model="loan_money_min" placeholder="最低(万)" style="width: 72px;" />
						<span class="add_title">--</span>
						<Input v-model="loan_money_max" placeholder="最高(万)" style="width: 72px;" />
					</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
					<div class="input-group">
						<span class="input-group-addon">媒体类型</span>
						<Select v-model="mediumType"  style="width:150px;" clearable placeholder="媒体类型">
							<Option value="1" >金掌柜平台</Option>
							<Option value="2" >第三方平台</Option>
						</Select>
					</div>
				</Col>
				<Button @click="mySearch" type="primary" >搜索</Button>
			</Row>
			<Row style="padding-top: 20px;">
				<Col style="float: left;">
				<Button @click="initSearch" type="primary" style="margin-left: 20px;">重置刷新</Button>
				<Button @click="()=>{uploadModal = true}" type="primary" style="margin-left: 20px;" v-if="userInfo.role_type == 4 || userInfo.role_type == 5">导入数据</Button>
				<Button @click="giveOutModal = true" type="primary" style="margin-left: 20px;">批量分配</Button>
				<Button @click="delClient" type="primary" style="margin-left: 20px;" v-if="userInfo.role_type == 4">批量删除</Button>
				</Col>
			</Row>
		</card>
		<div class="multiple" style="width: 100%">
            <Table :columns="pool_columns" :data="datas"  ref="table" style="width: 100%">
                <template slot-scope="{ row }" slot="name">
					<span :class="{grey:row.has_follow == true}" style="color:#63B3E6;cursor: pointer;" @click.stop="edit" :data-id="row.id" :data-name="row.name">{{row.name}}</span>
                </template>
                <template slot-scope="{ row }" slot="sex">
                    <span :class="{grey:row.has_follow == true}">{{row.sex_name}}</span>
                </template>
                <template slot-scope="{ row }" slot="age">
                    <span :class="{grey:row.has_follow == true}">{{row.age}}</span>
                </template>
                <template slot-scope="{ row }" slot="media">
                    <span :class="{grey:row.has_follow == true}">{{row.media_name}}</span>
                </template>
                <template slot-scope="{ row }" slot="need_limit">
                    <span :class="{grey:row.has_follow == true}">{{row.loans_money}}</span>
                </template>
                <template slot-scope="{ row }" slot="level">
                    <span :class="{grey:row.has_follow == true}">{{row.start_name}}</span>
                </template>
                <template slot-scope="{ row }" slot="created_at">
                    <span :class="{grey:row.has_follow == true}">{{row.applied_at}}</span>
                </template>
                <template slot-scope="{ row }" slot="recycle_time">
                    <span :class="{grey:row.has_follow == true}">{{row.collect_at}}</span>
                </template>
                <template slot-scope="{ row }" slot="not_follow_time">
                    <span :class="{grey:row.has_follow == true}">{{row.updated_at}}</span>
                </template>
                <template slot-scope="{ row }" slot="history_state">
                    <span :class="{grey:row.has_follow == true}">{{row.status_name}}</span>
                </template>
                <template slot-scope="{ row }" slot="follow_number">
                    <span :class="{grey:row.has_follow == true}">{{row.follow_times}}</span>
                </template>
				<template slot-scope="{ row }" slot="entrust">
					<div v-for="(item,index) in row.entrust" style="margin: 3px 0" :key="index">{{item.content}}  {{item.created_at}}
					</div>
					<div v-if="row.entrust.length == 0">无</div>
				</template>
				<template slot-scope="{ row }" slot="loans_money">
					<span>{{ row.loans_money / 10000 }}万</span>
				</template>
                <template slot-scope="{ row }" slot="operation">
                    <div style="display: flex; flex-direction: column; align-items: center; height: 60px; justify-content: space-around;">
                        <span @click="getCustomer" :data-id="row.id"   style="color: #FFFFFF; cursor: pointer; background-color: #02A3E0; border-radius: 10px; width: 80px; text-align: center;">领取客户</span>
                        <span @click="addSea" :data-id="row.id" style="color: #63B3E6; cursor: pointer;" >加入公海</span>
                    </div>
                </template>
            </Table>
		</div>
		<div class="pager1">
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
		<!-- 编辑/新增客户 -->
		<div v-if="editDiv" style="background: #f9fafc;">
			<Modal v-model="editModal" width="95%" title="" footer-hide :styles="editModalStyle">
				<NewEditClue @reloadData="getList" @beforeOne="beforeEditOne" @nextOne="nextEditOne" :id="clientId">
				</NewEditClue>
			</Modal>
		</div>

		<!-- 添加跟进记录 -->
		<Modal v-model="modal" width="1200" footer-hide>
			<quickEditClue @quickEditClient="quickEditClient" @reloadData="getList" @beforeOne="beforeOne"
				@nextOne="nextOne" :id="addRecordId"></quickEditClue>
		</Modal>
		<!-- 选择分配人 -->
		<Modal v-model="giveOutModal" width="650" title="选择分配人">
			<div class="multiple" style="margin-top: 0">
				<div class="child-div in-block">分配给</div>
				<Checkbox :value="checkAll" @click.prevent.native="handleCheckAll" :indeterminate="indeterminate"><span>全选</span></Checkbox>
				<CheckboxGroup v-model="giveOutUid" @on-change="checkAllGroupChange">
					<Checkbox v-for="item in userList" :label="item.id"><span>{{item.name}}</span></Checkbox>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button type="primary" @click="giveOutBatch">确定</Button>
			</div>
		</Modal>
		<!-- 客户提醒 -->
		<Modal v-model="clientTipsModal" :title="clientTips.title" cancel-text="">
			<p v-if="clientTips.type == 1">您与<span class='client_name' @click='edit'
					:data-id='clientTips.id'>{{clientTips.name}}</span>客户约定{{clientTips.plat_at}}回电/上门已到期，请及时处理</p>
			<p v-if="clientTips.type == 2">您有一条新客户<span class='client_name' @click='edit'
					:data-id='clientTips.id'>{{clientTips.name}}</span>进入系统，请及时处理</p>
		</Modal>
		<!--上传资料modal-->
		<Modal v-model="uploadModal" title="导入数据" width="600px" @on-cancel="() => {uploadModal = false}">
			<Steps :current="current_import_step">
				<Step title="上传文件" content="导入文件"></Step>
				<Step title="导入数据" content="导入数据"></Step>
				<Step title="导入完成" content="导入完成"></Step>
			</Steps>
			<div class="flex flex_between" style="padding: 5px 30px">
				一、根据模板准备要导入的数据。<span><a href="https://jzgtest.gzldr.com/static/uploads/demo.xlsx"
						style="color: #00a0e9">点击下载模板</a></span>
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				三、选择导入文件
				<Upload :before-upload="handleUpload" :on-success="uploadSuccess" :data="importData" :action="actionUrl">
					<Button icon="ios-cloud-upload-outline"
						>{{loadingStatus?'导入中':'选择文件'}}</Button>
				</Upload>
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<span>总数量：{{importDetailData.success+importDetailData.is_exist_num+importDetailData.is_phone_num}}     成功数量：{{importDetailData.success}}     撞库数量：{{importDetailData.is_exist_num}}     手机号错误数量：{{importDetailData.is_phone_num}}</span>
			</div>
		</Modal>
	</div>
</template>
<script>
	import config from '../../config';
	import quickEditClue from './quickEditClue.vue'
	import EditClue from './EditClue.vue'
	import NewEditClue from './NewEditClue.vue'
	import {
		mapMutations,
		mapActions,
		mapGetters
	} from "vuex";
	import {
		getList,
		addSea,
		addPool,
		allUnlock,
		lock,
		giveOut,
		getCount,
		delClient,
	} from '@/api/client'
	import {
		getUserList,
		getMyClientTips,
		getAnnounce,
		getTeamList,
	} from '@/api/user'
	import {
		getAllMediumCode
	} from "../../api/runSet";

	export default {
		name: "publicPool",
		components: {
			quickEditClue,
			EditClue,
			NewEditClue
		},
		props: {
			needInitSearch: {
				type: Boolean
			},
			menuName: {
				type: String
			},
			openMenuName: {
				type: String
			},
		},
		data() {
			return {
				clientTips: {
					title: '',
					clientId: 0,
					type: 0,
					name: '',
					plat_at: '',
				},
				clientTipsModal: false,
				uploadModal: false,
				notFollowTime: false,
				importData:{
					importType:2,
					importShopid:'',
				},
				importDetailData:{},
				loadingStatus: false,
				apply_time:[],
				join_time:[],
				updated_at:[],
				re_time:[],
				followTimes: 0,
				followUid: [],
				loanMoney: 0,
				start: [],
				status: [],
				is_follow: false,
				is_house: '',
				is_car: '',
				is_accumulation: '',
				is_social_security: '',
				is_weilidai: '',
				is_salary: '',
				is_credit_card: '',
				is_pay_taxes: '',
				houseShow:'',
				orderBy:0,
				indeterminate: true,
				checkAll: false,
				mediumType:'',
				editModalStyle: {
					'top': '7%',
					'background': '#f9fafc',
					'border-radius': '15px'
				},
				editDiv: false,
				editModal: false,
				current_import_step:0,
				clientId: 0,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100, 500],
				announce: '',
				announceImg: require('../../assets/images/announce.png'),
				countDataImg: {
					exclamatory: require('../../assets/images/exclamatory.png'),
					refresh: require('../../assets/images/refresh.png'),
				},
				conditionLise: [{
						value: 0,
						label: '无'
					},
					{
						value: 1,
						label: '有'
					}
				],
				sortLise: [{
						value: 1,
						label: '申请时间降序'
					},
					{
						value: 2,
						label: '申请时间升序'
					},
					{
						value: 3,
						label: '备注时间降序'
					},
					{
						value: 4,
						label: '备注时间升序'
					},
					{
						value: 5,
						label: '分配时间降序'
					},
					{
						value: 6,
						label: '分配时间升序'
					}
				],
				countData: {
					soon_collect: '**',
					un_lock: '**',
					untreated: '**',
					not_follow_5: '**',
					not_follow_3: '**',
					not_follow_1: '**',
					not_follow_1_start: '**',
				},
				giveOutId: 0,
				giveOutUid: [],
				giveOutModal: false,
				addRecordId: 0,
				foldShow: false,
				modal: false, //添加跟进记录
				media: [], //媒体代码
				apply: [], //申请条件
				count: 0,
				page: 1,
				name: '',
				remark:'',
				timeDimension: [],
				timePeriod: 0,
				notFollowTimeValue: '',
				call_tag: [],
				isComment: 0,
				userList: [],
				is_offer: [],
				makeState: [],
				clientType: [],
				timePeriodDate: [],
				categoryList: [],
				oldDatas: [],
				datas: [],
				loan_money_min:'',
				loan_money_max:'',
				actionUrl:'',
				optionMy: {
					tooltip: {
						trigger: 'item',
						formatter: '{b} :  ({d}%)'
					},
					toolbox: {
						show: true,
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					legend: {
						top: 10,
						orient: 'vertical',
						left: 'left',
						data: ['M0', 'M1', 'M2', 'M3以上']
					},
					series: [{
						name: 'Access From',
						type: 'pie',
						radius: '50%',
						label: {
							normal: {
								formatter: '{b}:{c}: ({d}%)',
								textStyle: {
									fontWeight: 'normal',
									fontSize: 15
								}
							}
						},
						data: [{
								value: 0,
								name: 'M0',
							},
							{
								value: 0,
								name: 'M1'
							},
							{
								value: 0,
								name: 'M2'
							},
							{
								value: 0,
								name: 'M3以上'
							},
						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				},
				options1: {
                    shortcuts: [
                       {
                            text: '1 month',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {
                            text: 'Yesterday',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            }
                        },
                       {
                            text: '1 month',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                    ]
                },				
				statusFilters: [{
					label: '未处理',
					value: '1'
				}, {
					label: '待跟进',
					value: '2'
				}, {
					label: '邀约中',
					value: '3'
				}, {
					label: '上门未签约',
					value: '6'
				}, {
					label: '已签约',
					value: '7'
				}, {
					label: '进件中',
					value: '8'
				}, {
					label: '银行拒绝',
					value: '9'
				},{
					label: '已回款',
					value: '13'
				}, {
					label: '资质不符',
					value: '14'
				}, {
					label: '捣乱申请',
					value: '15'
				}, {
					label: '外地申请',
					value: '16'
				}, {
					label: '重复申请',
					value: '17'
				}],
				starsFilters: [
						{
				    value: 0,
				    label: '0星'
				},
				{
				    value: 1,
				    label: '1星'
				},
				{
				    value: 2,
				    label: '2星'
				},
				{
				    value: 3,
				    label: '2星+'
				},
				{
				    value: 4,
				    label: '3星'
				},
				{
				    value: 5,
				    label: '4星'
				},
				],
				houseLise:[
					{
						value:0,
						label:'无'
					},
					{
						value:1,
						label:'有'
					}
				],
                pool_columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        "title": "客户",
                        "slot": "name",
                        "minWidth": 130
                    },
					{
						"title": "客户id",
						"key": "id",
						"width": 80
					},	
                    {
                        "title": "性别",
                        "slot": "sex",
                        "minWidth": 60,
                    },
                    {
                        "title": "年龄",
                        "slot": "age",
                        "minWidth": 60,
                    },
                    {
                        "title": "媒体代码",
                        "slot": "media",
                        "minWidth": 100
                    },
					{
						"title": "跟进记录",
						// "key": "entrust",
						slot: 'entrust',
						"width": 220
					},					
                    {
                        "title": "需求额度",
                        "slot": "loans_money",
                        "minWidth": 100,

                    },
                    {
                        "title": "星级",
                        "slot": "level",
                        "minWidth": 80,
                    },

                    {
                        "title": "申请时间",
                        "slot": "created_at",
                        "minWidth": 110,
                        "sortable": true
                    },
                    {
                        "title": "进入公共池时间",
                        "slot": "recycle_time",
                        "minWidth": 110,
                        "sortable": true
                    },
                    {
                        "title": "最近跟进时间",
                        "slot": "not_follow_time",
                        "minWidth": 130,
                        "sortable": true
                    },
                    {
                        "title": "跟进次数",
                        "slot": "follow_number",
                        "minWidth": 100,
                        filters: [{value:1,label:'0次'},{value:2,label:'1-3次'},{value:3,label:'4-10次'},{value:4,label:'11-20次'},{value:5,label:'20次以上'},],
                        filterMultiple: false,
                        filterMethod(value, row) {
                            if (value == 1) {
                                return row.follow_times == 0;
                            } else if (value == 2) {
                                return row.follow_times > 0 && row.follow_times <= 3;
                            } else if (value == 3) {
                                return row.follow_times > 3 && row.follow_times <= 10;
                            } else if (value == 4) {
                                return row.follow_times > 10 && row.follow_times <= 20;
                            } else if (value == 5) {
                                return row.follow_times > 20;
                            }
                        }
                    },
                    {
                        "title": "操作",
                        "slot": "operation",
                        "minWidth": 100
                    }
                ],
				columnsCopy: [
				    {
				        type: 'selection',
				        width: 60,
				        align: 'center'
				    },
				    {
				        "title": "客户",
				        "slot": "name",
				        "minWidth": 130
				    },
					{
						"title": "客户id",
						"key": "id",
						"width": 80
					},	
				    {
				        "title": "性别",
				        "slot": "sex",
				        "minWidth": 60,
				    },
				    {
				        "title": "年龄",
				        "slot": "age",
				        "minWidth": 60,
				    },
				    {
				        "title": "媒体代码",
				        "slot": "media",
				        "minWidth": 100
				    },
					{
						"title": "跟进记录",
						// "key": "entrust",
						slot: 'entrust',
						"width": 220
					},					
				    {
				        "title": "需求额度",
				        "slot": "loans_money",
				        "minWidth": 100,
				    },
				    {
				        "title": "星级",
				        "slot": "level",
				        "minWidth": 80,
				    },
				
				    {
				        "title": "申请时间",
				        "slot": "created_at",
				        "minWidth": 110,
				        "sortable": true
				    },
				    {
				        "title": "进入公共池时间",
				        "slot": "recycle_time",
				        "minWidth": 110,
				        "sortable": true
				    },
				    {
				        "title": "最近跟进时间",
				        "slot": "not_follow_time",
				        "minWidth": 130,
				        "sortable": true
				    },
				    {
				        "title": "跟进次数",
				        "slot": "follow_number",
				        "minWidth": 100,
				        filters: [{value:1,label:'0次'},{value:2,label:'1-3次'},{value:3,label:'4-10次'},{value:4,label:'11-20次'},{value:5,label:'20次以上'},],
				        filterMultiple: false,
				        filterMethod(value, row) {
				            if (value == 1) {
				                return row.follow_times == 0;
				            } else if (value == 2) {
				                return row.follow_times > 0 && row.follow_times <= 3;
				            } else if (value == 3) {
				                return row.follow_times > 3 && row.follow_times <= 10;
				            } else if (value == 4) {
				                return row.follow_times > 10 && row.follow_times <= 20;
				            } else if (value == 5) {
				                return row.follow_times > 20;
				            }
				        }
				    },
				    {
				        "title": "操作",
				        "slot": "operation",
				        "minWidth": 100
				    }
				],
				menu: 'media_set',
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo']),
			isRefreshGetListStatus() {
				return this.$store.state.app.isRefreshGetListStatus
			},
		},
		mounted: function() {
			this.actionUrl = config.baseUrl.dev + '/app/api/importPoolClient';
			this.importData.importShopid = this.userInfo.shop_id
			this.importData.followUid = this.userInfo.id
			this.userDisplayTable();
			this.loadData();
			this.getCount();
			this.getList();
		},
		created: function() { //这里是定时器

		},
		watch: {
			menuName() {
				this.getList();
			},
		},
		methods: {
			...mapMutations([
				'setisRefreshGetListStatus'
			]),
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			userDisplayTable() {
				// type: 4 分公司负责人   5 区长
				if (this.userInfo.media_is_open !== true) { //此处判断不用用户类型是否有有对应的列权限
					this.pool_columns = this.pool_columns.filter(col => col.slot !== 'media')
				} else {
					this.pool_columns = this.columnsCopy
				}
			},
			handleUpload: function(res) {
				let that = this;
				return new Promise(function(resolve, reject) {
					that.$Modal.confirm({
						title: '系统提示',
						content: '<p>确定导入吗？</p>',
						onOk: () => {
							that.loadingStatus = true;
							that.current_import_step = 1;
							resolve();
						},
						onCancel: () => {
							reject();
						}
					});
				});
			},
			uploadSuccess(e) {
				var that = this;
				that.loadingStatus = false;
				that.importDetailData =e.data
				if (e.code != 1) {
					that.$Message.warning(e.msg);
					return;
				}
			},
			async getAnnounce() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getAnnounce(that, data);
				if (res.code == 1) {
					that.announce = res.data.text;
				}
			},
			getCustomer(e) {
			    var that = this;
			    this.giveOutId = e.currentTarget.dataset.id;
			    this.$Modal.confirm({
			        title: '确认领取该客户吗吗？',
			        onOk: async () => {
			            that.giveOutUid = that.userInfo.id;
			            that.giveOutBatch();
			        }
			    })
			},
			async myTips() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getMyClientTips(that, data);
				if (res.code == 1) {
					that.clientTipsModal = true;
					that.clientTips = res.data;
				}
			},
			rowClassName(row, index) {
				if (row.is_updated > 0) {
					return 'table-blue-row';
				}else{
					return 'table-black-row';
				}
			},
			mySearchByFollow(followUid) {
				this.followUid = followUid;
				this.page = 1;
				this.getList();
			},
			mySearchByMoney(loanMoney) {
				this.loanMoney = loanMoney[0];
				this.page = 1;
				this.getList();
			},
			mySearchByContact(call_tag) {
				this.call_tag = call_tag;
				this.page = 1;
				this.getList();
			},
			mySearchByStatus(status) {
				this.status = status;
				this.page = 1;
				this.getList();
			},
			mySearchByStart(start) {
				this.start = start;
				this.page = 1;
				this.getList();
			},
			mySearchByDepartment(followDepartment) {
				this.followDepartment = followDepartment;
				this.page = 1;
				this.getList();
			},
			mySearchByMoney(loanMoney) {
				this.loanMoney = loanMoney[0];
				this.page = 1;
				this.getList();
			},
			mySearchByContact(call_tag) {
				this.call_tag = call_tag;
				this.page = 1;
				this.getList();
			},
			mySearchByCar(is_car) {
				this.is_car = is_car;
				this.page = 1;
				this.getList();
			},
			mySearchByHouse(is_house) {
				this.is_house = is_house;
				this.page = 1;
				this.getList();
			},
			mySearchByAccumulation(is_accumulation) {
				this.is_accumulation = is_accumulation;
				this.page = 1;
				this.getList();
			},
			mySearchBySocial(is_social_security) {
				this.is_social_security = is_social_security;
				this.page = 1;
				this.getList();
			},
			mySearchByWeilidai(is_weilidai) {
				this.is_weilidai = is_weilidai;
				this.page = 1;
				this.getList();
			},
			mySearchBySalary(is_salary) {
				this.is_salary = is_salary;
				this.page = 1;
				this.getList();
			},
			mySearchBySort(orderBy) {
				this.orderBy = orderBy;
				this.page = 1;
				this.getList();
			},
			mySearchByCreditCard(is_credit_card) {
				this.is_credit_card = is_credit_card;
				this.page = 1;
				this.getList();
			},
			mySearchByPayTaxes(is_pay_taxes) {
				this.is_pay_taxes = is_pay_taxes;
				this.page = 1;
				this.getList();
			},
			// 删除客户
			delClient(e) {
				let that = this;
				let selectTion = this.$refs["table"].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				});
				this.$Modal.confirm({
					title: "确认批量删除吗？",
					onOk: async () => {
						let res = await delClient(that, {
							token: that.token,
							id: ids,
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					},
				});
			},
			mySearch() {
				this.page = 1;
				this.getList();
			},
			addRecordClick(e) {
				let id = e.currentTarget.dataset.id;
				this.oldDatas = this.datas;
				this.addRecordId = id;
				this.modal = true;
			},
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
			},
			applyTimeChange(e) {
				this.apply_time = e;
			},
			updatedTimeChange(e){
				this.updated_at = e;
			},
			joinTimeChange(e) {
				this.join_time = e;
			},
			reTimeChange(e) {
				this.re_time = e;
			},
			async loadData() {
				let that = this;
				if (that.needInitSearch) {
					that.initSearch();
				}
				var data = {
					token: this.token,
					only_customer: 1
				};
				let res = await getAllMediumCode(that, data);
				if (res.code == 1) {
					that.categoryList = res.data.list;
				}
				var data = {
					token: that.token,
					getSelf: 1,
				};
				res = await getTeamList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
				}
			},
			async getCount() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getCount(that, data);
				if (res.code == 1) {
					that.$Message.success('获取成功');
					that.countData = res.data;
				}
			},
			initSearch() {
				this.name = '';
				this.timeDimension = [];
				this.timePeriod = 0;
				this.notFollowTime = false;
				this.isComment = 0;
				this.page = 1;
				this.apply = [];
				this.media = [];
				this.start = [];
				this.status = [];
				this.call_tag = [];
				this.is_offer = [];
				this.remark = '';
				this.clientType = [];
				this.timePeriodDate = [];
				this.apply_time = [];
				this.join_time = [];
				this.updated_at = [];
				this.re_time = [];
				this.notFollowTimeValue = "";
				this.loan_money_min = '';
				this.loan_money_max='';
				this.mediumType = '';
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.limit = this.pageSize;
				data.menu = this.menu;
				data.token = this.token;
				data.page = this.page;
				let res = await getList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
				//that.$emit('searchNameMenuItem', res.data.menuName, res.data.openMenuName);
				that.getUserInfo();
			},
			addClue() {
				let that = this;
				this.clientId = 0;
				this.editDiv = true;
				this.$nextTick(function() {
					that.oldDatas = that.datas;
					that.editModal = true;
				})
			},
			edit(e) {
				let that = this;
				let id = e.id || e.currentTarget.dataset.id;
				let name = e.name || e.currentTarget.dataset.name;
				this.$nextTick(function() {
					/*
					that.oldDatas = that.datas;
					that.editModal = true;
					*/
					this.$router.push({
						name: 'newEditClue',
						params: {
							id: id,
							name:name,
							data: that.datas
						},
					})

				})
			},
            handleCheckAll () {
                if (this.indeterminate) {
                    this.checkAll = false;
                } else {
                    this.checkAll = !this.checkAll;
                }
                this.indeterminate = false;

                if (this.checkAll) {
					for(let i in this.userList){
						this.giveOutUid.push(this.userList[i].id);
					}
                } else {
                    this.giveOutUid = [];
                }
            },
            checkAllGroupChange (data) {
                if (data.length === 3) {
                    this.indeterminate = false;
                    this.checkAll = true;
                } else if (data.length > 0) {
                    this.indeterminate = true;
                    this.checkAll = false;
                } else {
                    this.indeterminate = false;
                    this.checkAll = false;
                }
            },
			clickGiveOut(e) {
				let that = this;
				this.giveOutId = e.currentTarget.dataset.id;
				that.giveOutModal = true;
			},
			giveOut() {
				let that = this;
				let ids = that.giveOutId;
				let data = {
					ids: ids,
					uid: that.giveOutUid,
					token: that.token
				}
				that.throttle(async function() {
					let res = await giveOut(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.giveOutModal = false;
						that.setisRefreshGetListStatus(2);
						that.getList();
					}
				}, 2000);
			},
			giveOutBatch() {
				let that = this;
				let selectTion = this.$refs['table'].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				})
				let data = {
					ids: ids,
					uid: that.giveOutUid,
					token: that.token
				}
				that.throttle(async function() {
					let res = await giveOut(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.giveOutModal = false;
						that.setisRefreshGetListStatus(Date.parse(new Date()));
						that.getList();
					}
				}, 2000);
			},
			allUnlock() {
				let that = this;
				let selectTion = this.$refs['table'].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				})
				this.$Modal.confirm({
					title: '确认批量解锁吗？',
					onOk: async () => {
						let res = await allUnlock(that, {
							token: that.token,
							ids: ids
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							//that.getList();
						}
					}
				})
			},
			addPoolBatch() {
				let that = this;
				let selectTion = this.$refs['table'].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				})
				this.$Modal.confirm({
					title: '确认批量加入公共池吗？',
					onOk: async () => {
						let res = await addPool(that, {
							token: that.token,
							id: ids
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},			
			addSea(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认加入公海吗？',
					onOk: async () => {
						let res = await addSea(that, {
							token: that.token,
							id: id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			addPool(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认加入公共池吗？',
					onOk: async () => {
						let res = await addPool(that, {
							token: that.token,
							id: id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			async getTipsList(e) {
				let that = this;
				var data = {};
				data.menu = e.currentTarget.dataset.type;
				data.token = this.token;
				data.limit = 10;
				let res = await getList(that, data);
				that.datas = res.data.list;
			},
			async lock(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let res = await lock(that, {
					token: that.token,
					id: id
				});
				if (res.code == 1) {
					that.$Message.success(res.msg);
					that.getList();
				}
			},
			quickEditClient() {
				this.clientId = this.addRecordId;
				this.addRecordId = 0;
				this.modal = false;
				this.editDiv = true;
				this.$nextTick(function() {
					this.editModal = true;
				})
			},
			beforeEditOne() {
				let that = this;
				let item = that.findBeforeArr(that.oldDatas, 'id', that.clientId);
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				that.clientId = item.id;
			},
			nextEditOne() {
				let that = this;
				let item = that.findNextArr(that.oldDatas, 'id', that.clientId);
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				that.clientId = item.id;
			},
			beforeOne() {
				let that = this;
				let item = that.findBeforeArr(that.oldDatas, 'id', that.addRecordId);
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				that.addRecordId = item.id;
			},
			nextOne() {
				let that = this;
				let item = that.findNextArr(that.oldDatas, 'id', that.addRecordId);
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				that.addRecordId = item.id;
			}
		}
	}
</script>
<style scoped lang="less">
	.form-list .info-inline .name {
	    float: left;
	    line-height: 38px;
	    background: #f0f0f0;
	    border-right: 1px solid #ddd;
	    padding: 0 18px;
	    border-top-left-radius: 4px;
	    border-bottom-left-radius: 4px;
	}
	.form-list {
	    width: 100%;
	    display: inline-block;
	    clear: both;
	    padding: 8px 0;
	}
	.form-list .info-inline {
	    width: 16%;
	    height: 40px;
	    float: left;
	    margin: 7px .5%;
	}
	.form-list .bor-al, .form-list .bor-at {
	    border: 1px solid #ddd;
	    border-radius: 4px;
	    width: 49%;
	    float: left;
	}
	.form-list .bor-al, .form-list .bor-at {
	    border: 1px solid #ddd;
	    border-radius: 4px;
	    width: 49%;
	    float: left;
	}
	.form-list .info-inline .right {
	    overflow: auto;
	    position: relative;
	}
	.form-list .mar-let {
	    margin-left: 2%;
	}
	.hong {
		color: #F56171;
		font-weight: bold;
		cursor: pointer;
	}

	.lan {
		color: #124386;
		font-weight: bold;
		cursor: pointer;
	}

	.sousuo {
		width: 100%;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	/deep/ .ivu-modal-content {
		background-color: #f9fafc;
	}

	/deep/ .ivu-table-header thead tr th {
		text-align: center !important;
	}

	/deep/ .ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	/deep/ .ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	.count_tips {
		color: rgb(0, 0, 0);
		justify-content: center !important;
		background: rgb(229, 245, 253);
		width: 1400px;
		margin: 0 auto;
		/* padding: 5px; */
		line-height: 35px;
		height: 35px;
	}

	.count_tips_img {
		width: 15px;
		height: 15px;
		vertical-align: middle;
		margin-right: 5px;
		margin-bottom: 3px;
	}

	.announce_div {
		position: relative;
		background-color: #F2F2F2;
		color: #E8410B;
		margin-bottom: 20px;
	}

	.announce_img {
		position: absolute;
		left: 4px;

		img {
			width: 20px;
			height: 20px;
			margin-top: 5px;
		}
	}

	.announce_area {
		margin-left: 25px;
		overflow: hidden;

		marquee {
			margin-top: 5px;
		}
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}

	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
